import i18n from "src/locales/index";


export const types = {
	CLOSE: 1,
	OPEN: 2,
	BOOL: 3,
	COMPARISON: 4,
	TERM: 5,
};

export const dic = {
	[types.CLOSE]: i18n.t("pages.createQuestion.type.close"),
	[types.OPEN]: i18n.t("pages.createQuestion.type.open"),
	[types.BOOL]: i18n.t("pages.createQuestion.type.yesNo"),
	[types.COMPARISON]: i18n.t("pages.createQuestion.type.comparison"),
	[types.TERM]: i18n.t("pages.createQuestion.type.concept"),
};

const defaultConfig = { multiAnswer: false, questionRequired: true, addMedia: true, mediaInAnswer: false };
export const config = {
	[types.CLOSE]: Object.assign({}, defaultConfig, { multiAnswer: true }),
	[types.OPEN]: Object.assign({}, defaultConfig, {}),
	[types.BOOL]: Object.assign({}, defaultConfig, {multiAnswer: false}),
	[types.COMPARISON]: Object.assign({}, defaultConfig, { mediaInAnswer: true, questionRequired: false }),
	[types.TERM]: Object.assign({}, defaultConfig, { questionRequired: false }),
};
export const getConfig = (type) => {
	return config[type];
};
export default {
	types,
	toString (type) {
		return dic[type] || "";
	},
	getAsOption () {
		return Object.values(types).map(type => {
			return { text: dic[type], value: type };
		});
	},
	getConfig: getConfig,

};
